import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BrandStatement from "@/components/BrandStatement";
import WhatToExpect from "@/components/WhatToExpect";
import EditorialMarquee from "@/components/EditorialMarquee";
import SignatureFlavours from "@/components/SignatureFlavours";
import Quality from "@/components/Quality";
import Catering from "@/components/Catering";
import FinalClose from "@/components/FinalClose";

const Home = () => {
  return (
    <main data-testid="home-page" className="grain bg-stone-950 text-stone-50">
      <Header />
      <Hero />
      <BrandStatement />
      <WhatToExpect />
      <EditorialMarquee />
      <SignatureFlavours />
      <Quality />
      <Catering />
      <FinalClose />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1c1917",
            color: "#fafaf9",
            border: "1px solid #292524",
            borderRadius: "0",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
